<!-- @Version: 1.0.0 -->
<div>
   <h1 class="one-row-element title" data-testid="header1" [style.text-align]="fieldItem.attribute_2 | posAndColor : 1 : POSITION.LEFT" [attr.color]="fieldItem.attribute_1 | posAndColor : 2 : COLOR.PRIMARY" [innerHTML]="fieldItem.attribute_3"></h1>
</div>
